import React from 'react';

// utils and dependencies
import PageMetaContent from 'components/__atoms/page-meta-content';
import { removeUndefineds } from '@/utils/functions';
import { fetchGet, fetchPost } from '@/utils/compiling';
import { Sections, PageBuilder, /*ComponentBuilder*/ } from '@/utils/page';
import { usePage } from 'providers/page';
import { useRouter } from 'next/router';

// import {
//   AllTemplates,
//   AllMetas,
//   AllComponents
// } from 'utils/components';

// config used to access the env variables
import getConfig from 'next/config';
const { serverRuntimeConfig: SERVER, /*publicRuntimeConfig: PUBLIC*/ } = getConfig();

// import {
//   AllTemplates,
//   AllMetas,
//   AllComponents
// } from 'utils/components';

// const AllTemplates = { Local: Local_Templates };

// const AllMetas = { Local: Local_Metas, General: General_Metas };

// const AllComponents = { Local: Local_Components, General: General_Components };

// Object.entries(ClientSpecific || {}).forEach(([pkgName, pkg]) => {
//   AllComponents[pkgName] = pkg.components;
//   AllMetas[pkgName] = pkg.metas;
// });

// console.log(321, AllComponents, AllMetas);

// console.log(222, {
//   AllTemplates,
//   AllMetas,
//   AllComponents
// });

export default function GeneralPage(props) {

  const router = useRouter();
  const { setter: pageCxtSetter } = usePage();

  React.useEffect(_ => {
    if (props) {
      pageCxtSetter(props);
    }
  }, [props]);

  if (router.isFallback) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          background: '#444',
          color: '#fff'
        }}
      >
        {/* building the route */}
        ...
        {/* &lt;/&gt; */}
      </div>
    );
  }

  // const buildComponent = buildComponentBuilder(AllComponents);
  // const components = [];

  // if (props?.pageBlocks) {
  //   props.pageBlocks.forEach((tuple, idx) => {
  //     components.push(
  //       buildComponent(tuple.props.fullComponentName, `dynamic-component-${idx}`, tuple.props, tuple?.children || [])
  //     );
  //   });
  // }

  // const PageTemplate = new AllTemplates.Local[(props.data.page.template || 'Page') + 'Template']();
  // console.log(111222, PageTemplate);

  if (props.error) {
    return <div data-generated-at={props.generatedAt}>
      This page had a problem rendering.<br />
      Please try again later.
    </div>;
  }

  try {
    const compToReturn = (
      <>
        <PageMetaContent
          {...props}
        />

        {/* <Header
          menuData={props?.menuData || []}
          fullpath={props?.fullpath}
        /> */}

        <main id="main">
          <Sections
            // AllComponents={AllComponents}
            page={props.data?.page}
            settings={props.data?.settings}
            theme={props.data?.theme}
            breadcrumb={props.data?.breadcrumb}
          />
          {
            // AllComponents[section.package][section.component]
          }
          {
            // here goes the components
          }
        </main>
      </>
    );
    return compToReturn;
  } catch (error) {
    return <div>
      This page had a problem rendering!<br />
      Please try again later.
    </div>;
  }
}

/**
 * Builder for breadcrumb during full build rountine (when all pages are
 * rendered at once).
 *
 * @param {string} current Fullpath of current rendenring page
 * @returns Array of objects with slug and name
 */
// function breadcrumbBuilderFromPath(current) {
//   const crumbs = [];

//   // eslint-disable-next-line no-constant-condition
//   while (true) {
//     current = current.endsWith('/') && current.length > 0 ? current.slice(0, -1) : current;

//     if (current.length === 0 || !current.includes('/')) {
//       break;
//     }

//     crumbs.push(slugsCached[current]);

//     let parts = current.split('/');
//     parts.pop();
//     current = parts.join('/');
//   }

//   crumbs.push({ slug: '/', name: 'Home', id: '' });

//   return crumbs.reverse();
// }

/**
 * Builder for breadcrumb during SSR or ISR rendering of one page
 *
 * @param {Page} page Object with data of current page
 * @return Promise<Array>
 */
// async function breadcrumbBuilderFromTree(page) {
//   let crumbs = [];
//   let pages = [];

//   try {
//     const breadcrumbResult = await Repo.get(PageRepo.findPageTree(), { id: page.id });
//     if (!breadcrumbResult?.data?.pageTree?.length) {
//       return [];
//     }

//     pages = breadcrumbResult?.data?.pageTree || [];
//   } catch (err) {
//     Logger.debug('[Page::breadcrumb] Failed to get page tree with query. Reason:', err);

//     return [];
//   }

//   crumbs = pages.map((entry) => {
//     return {
//       slug: entry.fullpath,
//       name: entry.title,
//       id: entry.id
//     };
//   });

//   crumbs.push({ slug: '/', name: 'Home', id: '' });

//   return crumbs.reverse();
// }

export async function getStaticPaths() {
  const [
    { data: catPages, error: catError },
    { data: allPages, error: pagesError }
  ] = await Promise.all([
    _ => { return []; },// fetchGet('categories'),
    fetchPost('pages')
  ]);

  if (catError || pagesError) {
    throw catError || pagesError;
  }

  const listOfPages = [];

  [...(catPages || []), ...(allPages || [])].forEach(page => {
    const pageId = page.autopath || page.slug || page.name;

    if (!pageId) {
      return;
    }

    listOfPages.push({
      params: {
        slug: [
          ...(pageId.replace(/^\//g, '')).split('/')
        ]
      },
      locale: ''
    });
  });

  return {
    paths: listOfPages,
    fallback: 'blocking' // false or 'blocking'
  };
  // const productId = serverRuntimeConfig.PRODUCT_ID;

  // // find all disponible pages
  // const pagesResult = await Repo.get(PageRepo.findAllByLanguage(), { productId });
  // let pages = [];
  // if (pagesResult?.data?.pages) {
  //   pages = pagesResult.data.pages;
  // }

  // // map the paths
  // let paths = [];
  // if (pages && pages?.length) {
  //   // make sure to process parent pages before its childrens
  //   pages.sort((a, b) => ('' + a.fullpath).localeCompare(b.fullpath));

  //   paths = pages.map((page) => {
  //     slugsCached[page.fullpath] = {
  //       slug: page.fullpath,
  //       name: page.title,
  //       id: page.id
  //     };

  //     let slug = page.fullpath;
  //     if (slug.startsWith('/')) {
  //       slug = slug.substring(1);
  //     }

  //     const props = {
  //       params: {
  //         slug: slug.split('/'),
  //         breadcrumb: breadcrumbBuilderFromPath(page.fullpath)
  //       }
  //     };

  //     return props;
  //   });
  // }

  // return {
  //   paths,
  //   fallback: 'blocking' // false or 'blocking'
  // };
}

export async function getStaticProps({ locale, params }) {
  let slug = params?.slug || ['/'];

  if (Array.isArray(slug)) {
    slug = slug.join('/');
  }

  if (slug.startsWith('_next') || slug.startsWith('favicon.ico')) {
    return {
      notFound: true,
      revalidate: 60
    };
  }

  const { data, error } = await fetchGet(
    'page/' + slug + (slug.includes('?') ? '&' : '?') +
    'withSettings=1&withTheme=1'
  );

  if (error) {
    console.error(`
Error fetching the page ${slug}.
Message: ${error?.message || error.toString()}
`);
    return {
      notFound: true,
      revalidate: 60
    };
  }

  // data.generatedAt = Date.now();

  try {
    const page = await PageBuilder(
      data.page,
      data.settings,
      data.theme,
      data.breadcrumb,
      // pageData.page,
      // settingsData,
      // themeData,
      // pageData.breadcrumb
    ).catch(error => {
      console.error(`\n\n
  PageBuilder failed:
  Page: ${slug}
  Error: ${error?.message || error.toString()}
  `);
    });

    return {
      // revalidate: SERVER.REVALIDATION_INTERVAL || 10, // ISR: just revalidate at given interval
      revalidate: 600, // ISR: revalidate every 10 minutes
      props: removeUndefineds({
        data: page || { error: 'Failed building the page. Read the logs for more info' },
        generatedAt: Date.now()
        // data
        // ...page,
        // messages: i18nMessages,
        // pageBlocks: pageBlocks,
        // menuData,
        // locale,
        // title: titleConfig?.value || page?.title
      })
    };
  } catch (error) {
    return {
      revalidate: SERVER.REVALIDATION_INTERVAL, // ISR: just revalidate at given interval
      props: { error: 'Failed building the page. Read the logs for more info' }
    };
  }
}
